'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileInsuranceDob', cobCarrierProfileInsuranceDob);

	cobCarrierProfileInsuranceDob.$inject = [
		'$timeout', '$location', 'Upload', 'sessionService', 'subjectObserverMessagesService',
		'observerService', 'carrierRegistrationService', 'validationService', '$stateParams'
	];

	var $timeout,
		$location,
		ngFileUpload,
		sessionService,
		subjectObserverMessagesService,
		observerService,
		validationService,
		$stateParams;
	var subjectMessages, observerMessages, carrierRegistrationService, cleanAgent, pendingTab;

	function cobCarrierProfileInsuranceDob(_$timeout_,
		_$location_,
		_ngFileUpload_,
		_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_validationService_,
		_$stateParams_) {
		$timeout = _$timeout_;
		$location = _$location_;
		ngFileUpload = _ngFileUpload_;
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		validationService = _validationService_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileInsuranceDob.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.getCoverage = getCoverage;
			scope.onEditClick = onEditClick;
			scope.onTrashClick = onTrashClick;
			scope.onSaveClick = onSaveClick;
			scope.onCancelClick = onCancelClick;
			scope.confirmDelete = confirmDelete;
			scope.cancelDelete = cancelDelete;
			scope.onAddClick = onAddClick;
			scope.goToTab = goToTab;
			scope.onDiscardFileClick = onDiscardFileClick;
			scope.onFileUploadStart = onFileUploadStart;
			scope.setIsDirty = setIsDirty;
			scope.onForceGo = onForceGo;
			scope.validateName = validateName;
			scope.validatePhone = validatePhone;
			scope.validateFax = validateFax;
			scope.validateEmail = validateEmail;
			scope.validateCoverage = validateCoverage;

			scope.m = {
				isBroker: sessionService.isBroker(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				loaded: false,
				edit: false,
				addNewRow: false,
				agents: [],
				newAgent: {},
				deleteAgent: {}
			};

			registerObserverHandlers();

			$timeout(function() {
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_LOAD);
			},
			100);
		}

		function loadData(data) {

			scope.m.loaded = true;

			scope.m.agents = [];
			scope.m.newAgent = {};

			scope.m.insuranceMessage = data.insuranceMessage;
			scope.m.brokerName = data.brokerName;

			angular.forEach(data.agents,
				function(agent) {
					var dobAgent = {
						certificateFileName: agent.certificateFileName,
						agentName: agent.agentName,
						agentId: agent.agentId,
						phone: agent.phone,
						extension: agent.extension,
						fax: agent.fax,
						email: agent.email,
						auto: agent.coverage.indexOf('AUTO') > -1,
						cargo: agent.coverage.indexOf('CARGO') > -1,
						general: agent.coverage.indexOf('GENERAL') > -1,
						workersComp: agent.coverage.indexOf('WORKERS_COMP') > -1
					};

					if (agent.certificateFileName) {
						dobAgent.hadCert = true;
					}

					this.push(dobAgent);
				},
				scope.m.agents);


		}

		function registerObserverHandlers() {

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_START_CHANGE_CARRIER_PROFILE_VIEW, handler: saveData },
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_INSUREANCE_DOB_LOADED, handler: loadData },
					{ message: observerMessages.COB_OBSERVER_SET_PENDING_TAB, handler: setPendingTab }
				]);

			scope.$on('$destroy',
				function() {
					window.onbeforeunload = undefined;
				});

			scope.$on('$locationChangeStart',
				function(event) {
					if (scope.m.isDirty) {
						if (!scope.ux_requirement_hack_for_scrolling) {
							if (!
							confirm('You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page. Are you sure you want to leave the page?')) {
								event.preventDefault();
							}
						}
					}

					scope.ux_requirement_hack_for_scrolling = false;
				});
		}

		function saveData(callback) {
			if (!scope.m.loaded) {
				return;
			}

			if (!scope.m.isDirty) {
				if (typeof (callback) === 'function')
					callback();

				return;
			}
			if (formIsValid()) {
				if (scope.m.addNewRow || scope.m.agents.length === 0) { //new row
					saveAgent(scope.m.newAgent, callback);

					return;
				} else {
					angular.forEach(scope.m.agents,
						function(agent) {
							if (agent.edit) {
								saveAgent(agent, callback);

								return;
							}
						});
				}
			} else {
				setSectionMessage(true);
				scope.pendingCallback = callback;

				$timeout(function() {
					scope.ux_requirement_hack_for_scrolling = true;
					$('.profile-insurance-DOB').animate({
						scrollTop: $('#error-summary').offset().top
					}, 200);
					setIsDirty();
				},
				1);
			}
		}

		function saveAgent(agent, callback) {
			var carrierId = -1;

			if ($stateParams.carrierId)
				carrierId = $stateParams.carrierId;

			setTimeout(function () {
				observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			}, 1);

			carrierRegistrationService.updateDobInsurance(carrierId,
				agent.agentId,
				agent.agentName,
				agent.phone,
				agent.extension,
				agent.fax,
				agent.auto,
				agent.cargo,
				agent.general,
				agent.workersComp,
				agent.email,
				agent.certificateFileName,
				agent.newDocumentExe,
				agent.newDocumentBase64,
				agent.newDocumentType,
				agent.hadCert)
				.then(function() {
					scope.m.edit = false;
					agent.edit = false;
					scope.m.isDirty = false;
					window.onbeforeunload = undefined;
					scope.m.addNewRow = false;

					observerService.sendMessageToSubject(scope,
						subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
						'insurance');

					if (typeof (callback) === 'function') {
						callback();
					} else {
						observerService.sendMessageToSubject(scope,
							subjectMessages.COB_SUBJECT_CARRIER_PROFILE_INSUREANCE_RELOAD);
					}

				})
				.catch(function(error) {
					console.log(error);
				}).finally(function () {
					observerService
						.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});
		}

		function setIsDirty() {
			scope.m.isDirty = true;

			window.onbeforeunload = function() {
				return 'You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page.';
			};
		}

		function getCoverage(agent) {
			var output = '';

			if (agent.auto)
				output = 'Auto, ';

			if (agent.cargo)
				output = output + 'Cargo, ';

			if (agent.general)
				output = output + 'General, ';

			if (agent.workersComp)
				output = output + 'Workers\' Comp ';

			if (output)
				output = output.replace(/,\s+$/gm, '');

			return output;
		}

		function onEditClick(agent) {
			scope.m.edit = true;
			agent.edit = true;

			cleanAgent = {
				agentName: agent.agentName,
				phone: agent.phone,
				extension: agent.extension,
				fax: agent.fax,
				email: agent.email,
				auto: agent.auto,
				cargo: agent.cargo,
				general: agent.general,
				workersComp: agent.workersComp,
				certificateFileName: agent.certificateFileName,
				certificateId: agent.certficateId
			};
		}

		function onTrashClick(agent) {
			scope.m.deleteAgent = agent;
		}

		function onSaveClick(agent) {
			if (agentIsValid(agent)) {
				saveAgent(agent);
			}
		}

		function onCancelClick(agent) {
			if (scope.m.edit) {
				agent.agentName = cleanAgent.agentName;
				agent.phone = cleanAgent.phone;
				agent.extension = cleanAgent.extension;
				agent.fax = cleanAgent.fax;
				agent.email = cleanAgent.email;
				agent.auto = cleanAgent.auto;
				agent.cargo = cleanAgent.cargo;
				agent.general = cleanAgent.general;
				agent.workersComp = cleanAgent.workersComp;
				agent.certificateFileName = cleanAgent.certificateFileName;

				scope.m.edit = false;
				agent.edit = false;
			} else if (scope.m.addNewRow || scope.m.agents.length === 0) {
				scope.m.newAgent.agentName = undefined;
				scope.m.newAgent.phone = undefined;
				scope.m.newAgent.extension = undefined;
				scope.m.newAgent.fax = undefined;
				scope.m.newAgent.email = undefined;
				scope.m.newAgent.auto = undefined;
				scope.m.newAgent.cargo = undefined;
				scope.m.newAgent.general = undefined;
				scope.m.newAgent.workersComp = undefined;
				scope.m.newAgent.certificateFileName = undefined;

				scope.m.addNewRow = false;
			}

			agent.nameError = '';
			agent.phoneError = '';
			agent.faxError = '';
			agent.emailError = '';
			agent.coverageError = '';
			scope.m.isDirty = false;
			window.onbeforeunload = undefined;
		}

		function confirmDelete() {
			scope.m.deleteAgent.agentName = '';
			saveAgent(scope.m.deleteAgent);
		}

		function cancelDelete() {
			scope.m.deleteAgent = {};
		}

		function onAddClick() {
			scope.m.addNewRow = true;
		}

		function goToTab(tab) {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_SET_PENDING_TAB, tab);
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_START_CHANGE_CARRIER_PROFILE_VIEW,
				navigate);
		}

		function setPendingTab(tab) {
			scope.tab = tab;
		}

		function navigate() {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				scope.tab);
		}

		function onDiscardFileClick(agent) {
			agent.certificateFileName = undefined;
			setIsDirty();
		}

		function onFileUploadStart(agent) {
			if (agent.fileUploaderFile) {
				setIsDirty();
				if (validateFile(agent)) {
					ngFileUpload.base64DataUrl(agent.fileUploaderFile, false)
						.then(function(url) {
							var nameSplit = agent.fileUploaderFile.name.split('.');

							agent.newDocumentBase64 = url.split(',')[1];
							agent.newDocumentType = agent.fileUploaderFile.type,
							agent.newDocumentExe = nameSplit[nameSplit.length - 1];
							agent.certificateFileName = agent.fileUploaderFile.name;
						});

				} else {
					agent.fileError = 'Only .pdf, .tif, .tiff, .jpg, .jpeg .png or .gif under 10mb allowed.';
				}
			}
		}

		function validateFile(agent) {
			var validMimeTypes = [
				'application/pdf', 'image/tiff', 'image/png', 'image/jpeg',
				'image/gif'
			];

			if (validMimeTypes.indexOf(agent.fileUploaderFile.type) > -1) {
				if (agent.fileUploaderFile.size < 10485760) {
					return true;
				}
			}

			return false;
		}

		function formIsValid() {
			var isValid = true;
			if (!scope.m.isDirty) {
				return true;
			} else if (scope.m.addNewRow || scope.m.agents.length === 0) { //new row

				if (!agentIsValid(scope.m.newAgent)) {
					isValid = false;
				}

			} else {
				angular.forEach(scope.m.agents,
					function(agent) {
						if (agent.edit) {
							if (!agentIsValid(agent)) {
								isValid = false;
							}
						}
					});
			}

			return isValid;
		}

		function agentIsValid(agent) {
			var isValid = true;
			validateName(agent);
			validatePhone(agent);
			validateFax(agent);
			validateEmail(agent);
			validateCoverage(agent);

			if (agent.nameError || agent.phoneError || agent.faxError || agent.emailError || agent.coverageError) {
				isValid = false;
			}

			return isValid;
		}

		function validateCoverage(agent) {
			if (!agent.auto && !agent.cargo && !agent.general && !agent.workersComp) {
				agent.coverageError = 'Please select at least one option.';
			} else {
				agent.coverageError = '';
			}
		}

		function validateName(agent) {
			if (!agent.agentName) {
				agent.nameError = 'Valid input is required';
			} else {
				agent.nameError = '';
			}
		}

		function validatePhone(agent) {
			if (!agent.phone) {
				agent.phoneError = 'Valid input is required';
			} else if (agent.phone.length !== 10) {
				agent.phoneError = 'Valid input is required';
			} else if (agent.phone[0] === '0' || agent.phone[0] === '1') {
				agent.phoneError = 'Valid input is required';
			} else {
				agent.phoneError = '';
			}
		}

		function validateFax(agent) {
			if (agent.fax && agent.fax.length !== 10) {
				agent.faxError = 'Valid input is required';
			} else if (agent.fax && (agent.fax[0] === '0' || agent.fax[0] === '1')) {
				agent.faxError = 'Valid input is required';
			} else {
				agent.faxError = '';
			}
		}

		function validateEmail(agent) {
			if (agent.email && !validationService.isValidEmail(agent.email)) {
				agent.emailError = 'Valid email is required';
			} else {
				agent.emailError = '';
			}
		}

		function onForceGo() {
			if (typeof (scope.pendingCallback) === 'function')
				scope.pendingCallback();
		}

		function setSectionMessage(show) {
			scope.m.showSectionMessage = show;
			if (show) {
				$timeout(function () {
					$('.carrier-profile-wrapper')
						.animate({
							scrollTop: $('#error-summary').offset().top
						},
						200);
				},
				10);
			}
		}
	}

})();
